import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import MainContainer from '../components/MainContainer';

const HomeScreen = ({ history }) => {
  const { loading, userInfo } = useSelector((state) => state.user);
  useEffect(() => {
    if (!loading && userInfo) {
      history.push('/dashboard');
    }
  }, [userInfo, history, loading]);
  return (
    <MainContainer>
      <h1>O que é o Explora?</h1>
      <p>
        É um instrumento de auto-avaliação criado para propiciar a identificação
        do seu potencial profissional. Foi desenvolvido tendo como base a
        inteligência empreendedora presente em cada indivíduo e apresenta um
        elevado índice de confiabilidade.
      </p>
      <p>
        De forma rápida e simples, você poderá conhecer quais são suas
        principais características e quais são as suas propensões de atividades
        profissionais.Uma vez preenchido o instrumento, você terá,
        instantaneamente, uma devolutiva do seu perfil.
      </p>
      <Row className='py-3'>
        <Col>
          <Link to='/register'>Clique e descubra o seu potencial.</Link>
        </Col>
      </Row>
    </MainContainer>
  );
};

export default HomeScreen;
